import { render, staticRenderFns } from "./QrScanner.vue?vue&type=template&id=8daafa46&lang=pug&"
import script from "./QrScanner.vue?vue&type=script&lang=ts&"
export * from "./QrScanner.vue?vue&type=script&lang=ts&"
import style0 from "./QrScanner.vue?vue&type=style&index=0&id=8daafa46&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports